export const ENVIRONMENT_GLOBAL = {
  envName: 'global',
  loggingEnabled: true,
  pageSize: 30,
  searchSelectPageSize: 10,
  debounceTime: 750,
  debounceTimeSearchSelect: 200,
  inputErrorSnackbarDuration: 3000,
  dialogs: {
    xlarge: {
      width: '960px',
      maxWidth: '960px',
      minWidth: '350px',
      // height: '100vh',
      // maxHeight: '1085px',
    },
    large: {
      width: '80vw',
      maxWidth: '850px',
      minWidth: '350px',
    },
    middle: {
      width: '80vw',
      maxWidth: '560px',
      minWidth: '280px'
    },
    small: {
      minWidth: '280px',
      maxWidth: '560px',
    }
  },
  appVersion: require('../../package.json').version,
  redirect: {
    route: '/oauth'
  },
  auth_L1: {
    endpoint: {
      paths: {
        account: '/account',
        login: '/protocol/openid-connect/auth',
        token: '/protocol/openid-connect/token',
        certs: '/protocol/openid-connect/certs',
        logout: '/protocol/openid-connect/logout',
        register: '/protocol/openid-connect/registrations'
      }
    }
  },
  backend: {
    endpoint: {
      paths: {
        prefix: '/api',
        token: '/auth/token',
        logout: '/auth/logout'
      }
    },
    wsEndpoint: '',
    wsHeartbeatIntervalMs: 20000
  },
  files: {
    paths: {
      prefix: '/docs',
      filePath: {}
    }
  },
  imprint: {
    endpoint: {
      paths: {
        imprint: '/impressum'
      }
    }
  },
  links: {
    data_security: 'https://www.hekatron-brandschutz.de/datenschutz',
    help: 'https://www.meinhplus.de/lernen/faq-haeufig-gestellte-fragen',
    marketing: 'https://www.hekatron-brandschutz.de/kontakt',
    homepage: 'https://www.meinhplus.de/',
    av: 'https://www.meinhplus.de/fileadmin/Bilder/MeinHplus/Impressum/Vereinbarung-Auftragsverarbeitung-AVV_Hekatron_HVG_HPlus-Office_Service-App.pdf',
    email: 'info@hekatron.de',
    applications: {
      hpo: '',
      mh2: '',
      hcp: '',
      oms: '',
      go: '',
      b2b: '',
      dongle: '',
      dongle_admin: '',
      elec_calc_tool: 'https://www.hekatron-planungstools.de/stromberechnung.php',
      tender_tool_extend: 'https://www.hekatron-planungstools.de/Extend.php',
      remote_admin: 'https://remote.meinhplus.de/admin',
      remote_desktop: 'https://remote.meinhplus.de/iac20desktop/',
      status: 'https://h.meinhplus.de/hplus-status-ihr-brandschutz-plus-fuer-aufschaltung',
      learn_world: '',
      ai_plan: 'https://plan.meinhplus.de'
    }
  },
  domain: {
    endpoint: {
      paths: {
        prefix: '/api/domain',
        companydata: '/companydata',
        logo: '/logo'
      }
    }
  },
  domains: {
    endpoint: {
      paths: {
        prefix: '/api/domains',
        profile: '/profile',
        usage: '/usage',
        invitation: '/invitation',
        accept: '/accept',
        reject: '/reject',
        leave: '/leave'
      }
    }
  },
  users: {
    endpoint: {
      paths: {
        prefix: '/api/users',
        applications: '/applications',
        overview: '/overview',
        exports: '/exports',
        profile: '/profile',
        invitations: '/invitations',
        csv: '/csv',
        resend: '/resend',
        onboardingCompleted: '/onboarding-completed'
      }
    }
  },
  usergroups: {
    endpoint: {
      paths: {
        prefix: '/api/usergroups',
        users: '/users',
        name: '/name',
        applications: '/applications',
        systems: '/systems',
        objects: '/objects',
        added: '/added',
        available: '/available',
        all_systems: '/all-systems',
        simple: '/simple'
      }
    }
  },
  systems: {
    endpoint: {
      paths: {
        prefix: '/api/systems'
      }
    }
  },
  addresses: {
    endpoint: {
      paths: {
        prefix: '/api/addresses',
        auto_complete: '/auto-complete'
      }
    }
  }
};
